// TODO remove Prefixes from Keys
export const CLASSES = {
  IS_ACTIVE: "is-active",
  IS_VISIBLE: "is-visible",
  IS_HIDDEN: "is-hidden",
  IS_OPEN: "is-open",
  IS_SHOW: "is-show",
  SELECTED: "is-selected",
  ERROR: "has-error",
  LOADER: "loader",
  LOADER_WRAPPER: "loader-wrapper"
};

export const KEYCODES = {
  BACKSPACE: 8,
  TAB: 9,
  ENTER: 13,
  SHIFT: 16,
  CTRL: 17,
  ALT: 18,
  PAUSE_BREAK: 19,
  CAPS_LOCK: 20,
  ESC: 27,
  SPACE: 32,
  PAGE_UP: 33,
  PAGE_DOWN: 34,
  END: 35,
  HOME: 36,
  LEFT_ARROW: 37,
  UP_ARROW: 38,
  RIGHT_ARROW: 39,
  DOWN_ARROW: 40,
  INSERT: 45,
  DELETE: 46,
  NUM_LOCK: 144,
  SCROLL_LOCK: 145
};

export const STRINGS = {
  FLOW_ERROR_TITLE: "Sorry, something went wrong with your Flow setup",
  FLOW_ERROR_MESSAGE: "Please try again later",
  UNKNOWN_ERROR:
    "Oops! Something went wrong! We will be looking into this with the utmost urgency.",
  THANKS_FOR_INTEREST:
    "Thank you for your interest. We’ll keep you in the loop on all the latest feature updates",
  EMAIL_VALIDATION_MESSAGE: "Wrong e-mail address"
};
